// @flow
import * as React from 'react';
import styled from 'styled-components';
import {
    Box, DropButton as GrommetDropButton,
} from 'grommet';
import { Down, Up } from 'grommet-icons';

const DropButton = styled(GrommetDropButton)`
    ${(props) => `
        border-color: ${props.borderColor || props.theme.global.colors.buttonBorder};
        border-width: 1px;
        min-height: 32px;
        height: auto;
        padding: 4px 15px;
        overflow: auto;
        
        @media only screen and (min-width: 1300px) {
            width: ${props.styles?.width || '210px'};
        }
        
        &:hover {
            box-shadow: 0px 0px 4px 2px #cfd0d3;
            // background-color: ${props.theme.global.colors.buttonBorder};
        }
        ${props.open ? 'box-shadow: 0px 0px 4px 2px #cfd0d3;'
        : ''}
        &:focus {
            outline: none;
        }
    `}
`;

const StyledSpan = styled.span`
  display: inline-block;
  width: 30px;
  float: right;
  text-align: right;
`;

type Props = {
    label: React.Node,
    choices: Array<{
        label: React.Node,
        onClick: Function,
    }>,
    disabled?: boolean,
    styles: Object,
    dropStyles: Object,
    align?: Object,
};

type MenuContentProps = {
    choices: Array<{
        label: React.Node,
        onClick: Function,
        rightSideLabel?: React.Node,
        disabled?: boolean,
    }>,
    setOpened: Function,
    align: Object,
    label: React.Node,
};

const MenuContent = (props: MenuContentProps) => {
    const {
        choices, setOpened, align, label,
    } = props;

    const choicesFiltered = choices.filter((choice) => {
        const cLabel = typeof choice.label === 'object' ? choice.label.props.id : choice.label;
        const _label = typeof label === 'object' ? label.props.id : label;
        return (cLabel !== _label);
    });
    return (
        <Box>
            {choicesFiltered.map((choice, i) => (
                <Box
                    background={choice.disabled && '#ecedef'}
                    key={typeof choice.label === 'string' ? choice.label : `key-${i}`}
                    pad={{ vertical: '4px', horizontal: '15px' }}
                    onClick={!choice.disabled ? () => {
                        setOpened(false);
                        choice.onClick();
                    }
                        : () => {}
                    }
                    hoverIndicator="light-3"
                    style={i === 0 ? {
                        boxShadow: `rgb(211, 213, 217) 0px
                    ${align?.bottom === 'top' ? '-' : ''}11px 4px -9px inset`,
                        display: 'inline-block',
                    } : {
                        display: 'inline-block',
                    }}
                >
                    {choice.label}
                    {choice.rightSideLabel && (
                        <StyledSpan>{choice.rightSideLabel}</StyledSpan>
                    )}
                </Box>
            ))}
        </Box>
    );
};

const Menu = (props: Props) => {
    const {
        label, choices, disabled, styles, dropStyles, align,
    } = props;

    const dropButtonRef = React.useRef(null);
    const [opened, setOpened] = React.useState(null);

    return (
        <>
            <DropButton
                ref={dropButtonRef}
                label={(
                    <Box direction="row" align="center" justify="between">
                        {label}
                        <Box margin={{ left: 'small' }}>
                            {opened ? <Up size="small" /> : <Down size="small" />}
                        </Box>
                    </Box>
                )}
                dropAlign={align}
                dropContent={(
                    <MenuContent
                        choices={choices}
                        setOpened={setOpened}
                        align={align}
                        label={label}
                    />
                )}
                dropProps={{
                    style: {
                        borderRadius: '6px',
                        maxWidth: '300px',
                        marginLeft: '2px',
                        ...dropStyles,
                    },
                }}
                dropTarget={dropButtonRef.current}
                onOpen={() => setOpened(true)}
                onClose={() => setOpened(false)}
                open={opened}
                focusIndicator={false}
                disabled={disabled}
                styles={styles}
            />
        </>
    );
};

Menu.defaultProps = {
    disabled: false,
    align: { top: 'bottom' },
};

export default Menu;
